export interface SmsFiltersState {
    smsFilters:any[],
    smsFilterItem?:any
}

export interface SmsFilterFilter {
    partner?: string,
    condition?: string,
    text?: string,
}
export interface SmsFilterItem {
    id?: number
    partner?: string,
    partner_id?: number|null,
    condition?: string,
    text?: string,
}

export class SmsFilterItemImpl implements SmsFilterItem{
    id?: number
    partner_id?: number|null
}